export const FullScreenModalConfig = {
  autoFocus: false,
  maxWidth: '100vw',
  maxHeight: '100vh',
  height: '100%',
  width: '100%',
  panelClass: 'fullscreen-modal',
  backdropClass: 'mg-menu-backdrop'
}

export const FullScreenModalWithPaddingConfig = {
  autoFocus: false,
  maxWidth: '98vw',
  maxHeight: '95dvh',
  height: '100%',
  width: '100%',
  panelClass: 'fullscreen-modal-with-padding'
}

export const NormalModalConfig = {
  autoFocus: false,
  panelClass: 'normal-modal',
  backdropClass: 'mg-menu-backdrop'
}

export const MobileMaxWidth = 768
